export default __webpack_public_path__ + "static/media/micThumbnail.45a39338.png";